import { useContext } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import MainLayout from './Layouts/MainLayout';
import MainRoutes from './Routes/MainRoutes';
import AuthContext from './Context/AuthContext';
import AuthRoutes from './Routes/AuthRoutes';
import FindEQID from './Pages/FindEQID';
import LandingPage from './Pages/LandingPage';
import LandingPage404 from './Pages/LandingPage404';

// These serve the public, customer-facing EQID page (reached by scanning a machine's
// QR code). They must render identically — no admin sidebar/navbar, no login gate —
// whether the visitor is logged out, or is an admin previewing the "Service Landing
// Page" link from Machine Orders, so they're rendered outside the isLoggedIn/MainLayout
// branching below rather than duplicated inside both MainRoutes and AuthRoutes.
const PUBLIC_PATHS = ['/find_eqid', '/eqid/:qr_id', '/eqid_notFound/:qr_id'];

function App() {

  const{isLoggedIn} = useContext(AuthContext)
  const location = useLocation();
  const isPublicPage = PUBLIC_PATHS.some((path) =>
    location.pathname === path.split('/:')[0] || location.pathname.startsWith(path.split('/:')[0] + '/')
  );

   return (
    <div className='font-abc'>
        {isPublicPage ? (
          <Routes>
            <Route path="/find_eqid" element={<FindEQID />} />
            <Route path="/eqid/:qr_id" element={<LandingPage />} />
            <Route path="/eqid_notFound/:qr_id" element={<LandingPage404 />} />
          </Routes>
        ) : isLoggedIn ?
          (<MainLayout>
            <MainRoutes />
          </MainLayout>)
          :
          (<AuthRoutes />)
        }
    </div>
  );
}

export default App;
